import React, { useState, useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import RecommendationSummary from "../../controls/recommendationSummary";
import { useAuth } from "../../Auth";
import api from "../../services/api";
// Import Swiper React components
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import SwiperPager from "../../controls/swiperPager";
// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Pagination, Keyboard } from "swiper/modules";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { LearningElement,LearningJourneyElement, LearningWrapper } from "./LearningStyles";
import icnCourse from "../../assets/images/icn_courses@2x.png";
import icnJourney from "../../assets/images/icn_journeys@2x.png";

const Learning = () => {
  const [loading, setLoading] = useState(true);
  const [learningData, setLearningData] = useState(null);
  const [recommendations, setRecommendations] = useState(null);
  const [activeTab, setActiveTab] = useState("recommended");
  const [courses, setCourses] = useState(null);
  const [currentSwiper, setCurrentSwiper] = useState(null);
  const [journeySwiper, setJourneySwiper] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchSwiper, setSearchSwiper] = useState(null);
  const searchDebounceRef = useRef(null);
  const { cmpData, environment, cuesURL, cmanURL, degreedURL, canSectionLoad, markSectionLoaded } = useAuth();
  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      // if (window.location.host == "mycues.cues.org") {
        // Push event to GTM data layer
        if (window.dataLayer) {
          const dataLayerEvent = {
            event: eventTitle,
            event_category: 'Learning',
            user_role: cmpData.account_info.acgiRole,
            user_memberlevel: cmpData.account_info.membershipLevel,
            user_company: cmpData.account_info.employer,
          };
          
          // Add value and course_name for events that have a value parameter
          if (value) {
            dataLayerEvent.event_label = value;
            dataLayerEvent.value = value;
            dataLayerEvent.course_name = value; // Add course_name as a separate dimension
          }
          
          window.dataLayer.push(dataLayerEvent);
        }
      // }
    }
  }
  function truncateStringWithPTag(inputString, maxLength) {
    if (inputString === undefined || inputString === null)
      return inputString;
    // Regular expression to match <p></p> tags and their content
    const regex = /(<([^>]+)>)/gi;

    // Replace all <p></p> tags with an empty string
    const stringWithoutPTags = inputString.replace(regex, '');

    // If there are no <p></p> tags, return the original input string
    if (!stringWithoutPTags.trim()) {
      return inputString;
    }

    // Truncate the resulting string to the specified maxLength
    if (stringWithoutPTags.length > maxLength) {
      const lastSpaceIndex = stringWithoutPTags.lastIndexOf(' ', maxLength);
      if (lastSpaceIndex !== -1) {
        return stringWithoutPTags.substring(0, lastSpaceIndex) + '...';
      }
      return stringWithoutPTags.substring(0, maxLength) + '...';
    }

    return stringWithoutPTags;
  }


  useEffect(() => {
    if (cmpData && canSectionLoad('cmp_my_cues_learning') && !learningData && cmpData?.account_info) {
      const novoedApiUrl = cuesURL + "/cmp/novoed";
      const persona = cmpData.account_info?.hasNovoEdCourseData !== true ? `?persona=${cmpData.account_info.acgiRole}` : "";
      const recommendationUrl = `${cuesURL}/course-recommendations/${cmpData.account_info?.memberId}${persona}`;
      
      // Mark as loaded immediately so other sections don't wait for learning
      markSectionLoaded('cmp_my_cues_learning');
      
      api.get(recommendationUrl)
        .then(function (response) {
          setRecommendations(response.data);
          return api.get(novoedApiUrl);
        })
        .then(function (response1) {
          setLearningData(response1.data);
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  }, [cmpData, canSectionLoad, cuesURL, learningData, markSectionLoaded]);

  useEffect(() => {
    if (!loading && recommendations && learningData) {
      switch (activeTab) {
        case "recommended":
          //console.log('recommended')
          const rawData = recommendations.recommendations;
          //setRecommendations(rawData)
          ////console.log(rawData)
          break;
        case "enrolled":
          let enrolledData = learningData.learning.enrolled;

          if (Array.isArray(enrolledData)) {
            const journeys = enrolledData.filter(item => item.type === "Journey");
            const otherTypes = enrolledData.filter(item => item.type !== "Journey");

            const sortedJourneys = journeys.sort((a, b) => {
              const dateA = new Date(a.order_date);
              const dateB = new Date(b.order_date);
              return dateB - dateA;
            });

            const sortedOtherTypes = otherTypes.sort((a, b) => {
              const getStatus = (item) => {
                if (item.completion_progress === "in_progress" && item.last_activity !== null) {
                  return "in_progress";
                } else if (item.last_activity === null) {
                  return "enrolled";
                } else {
                  return item.completion_progress;
                }
              };
              const statusA = getStatus(a);
              const statusB = getStatus(b);

              // First, compare the statuses
              if (statusA === "in_progress" && statusB === "enrolled") {
                return -1; // "in_progress" comes before "enrolled"
              } else if (statusA === "enrolled" && statusB === "in_progress") {
                return 1; // "enrolled" comes after "in_progress"
              } else {
                // If the statuses are the same or neither is "in_progress," compare by date in descending order
                const dateA = new Date(a.order_date);
                const dateB = new Date(b.order_date);
                return dateB - dateA;
              }
            });

            const enrolledSortedData = [...sortedJourneys, ...sortedOtherTypes];
            setCourses(enrolledSortedData);
          } else {
            setCourses([]);
          }

          break;
        case "completed":
          let completedData = learningData.learning.completed;

          if (Array.isArray(completedData)) {
            // Sort the enrolledData array by both 'order_date' and 'title' properties
            const completedSortedData = [...completedData].sort((a, b) => {
              // Compare by 'order_date' first
              const dateA = new Date(a.completed_at);
              const dateB = new Date(b.completed_at);
              if (dateA > dateB) {
                return -1;
              } else if (dateA < dateB) {
                return 1;
              } else {
                // If 'order_date' is the same, compare by 'title'
                const titleA = a.name.toLowerCase();
                const titleB = b.name.toLowerCase();
                return titleA.localeCompare(titleB);
              }
            });
            //console.log(`completed count:${completedData.length}`)
            setCourses(completedSortedData);
          } else {
            setCourses([]);
          }

          break;
        default:
          //console.log("I don't know what courses to show...");
      }
    }
  }, [loading, activeTab, recommendations, learningData]);
  const getLearningJourneys = () => {
    const rawData = learningData.learning.learning_journeys;
    
    if (Array.isArray(rawData)) {
      // Sort the rawData array by the 'title' property
      const sortedData = [...rawData].sort((a, b) => {
        const titleA = a.name.toLowerCase();
        const titleB = b.name.toLowerCase();
        return titleA.localeCompare(titleB);
      });
      //console.log('learning journeys')
     //console.log(sortedData)
     //console.log(sortedData.length)
      return sortedData;
    } else {
      return [];
    }
  }
  const handleRecommendationClick = (item) => {
    //console.log(`recommendation click:${item?.course_id}`)
    var url = 'https://dj55151rvi.execute-api.us-east-2.amazonaws.com/Prod/feedback';
    var body = {
      "userId": recommendations.user_id,
      "itemId": item.item_id,
      "eventType": "clicked",
      "recommendationId": item.recommendation_id,
      "campaign": "mcltoppicks",
      "sessionId": window.analytics.user().anonymousId()
    };
    api
      .post(url, body, { withCredentials: false })
      .then(function (response) {
        //console.log(response)
        //setLoading(false);
      })
      .catch(function (error) {
        //console.log(error)
      });
    //console.log(body)
  }
  const [step1open, setStep1open] = useState(localStorage.getItem('hasViewedOverlay') !== 'true');
  const [step2open, setStep2open] = useState(false);
  const [step3open, setStep3open] = useState(false);
  const [step4open, setStep4open] = useState(() => {
    // If the full overlay hasn't been viewed, step4 will be triggered as part of the sequence
    if (localStorage.getItem('hasViewedOverlay') !== 'true') return false;
    // For existing members who have seen the overlay but not the search tooltip
    return localStorage.getItem('hasViewedSearchOverlay') !== 'true';
  });

  const executeSearch = (term) => {
    if (!term.trim() || !recommendations || !learningData) return;
    const lowerTerm = term.toLowerCase();
    const resultMap = new Map();

    // Short acronyms that should match as whole words only (not substrings),
    // case-insensitive.
    const EXACT_MATCH_TERMS = ["ai", "hr", "de", "dei", "cfo", "ceo", "coo", "cio"];
    // Terms that must match as a whole word AND in uppercase only (e.g. "IT"
    // for Information Technology, not the pronoun "it").
    const UPPERCASE_EXACT_MATCH_TERMS = ["it"];

    const isExactMatchTerm = EXACT_MATCH_TERMS.includes(lowerTerm);
    const isUppercaseExactMatchTerm = UPPERCASE_EXACT_MATCH_TERMS.includes(lowerTerm);

    // Boundary set excludes hyphens and apostrophes so hyphenated words and
    // contractions are treated as single tokens. This ensures "de" won't match
    // "de-escalate" and "it" won't match "it's".
    const boundary = `[\\s.,!?;:()"\\[\\]{}<>/\\\\|]`;

    const matchesTerm = (text) => {
      if (!text) return false;
      if (isUppercaseExactMatchTerm) {
        // Case-sensitive whole-word match against the uppercase term.
        const regex = new RegExp(`(^|${boundary})${lowerTerm.toUpperCase()}(?=$|${boundary})`);
        return regex.test(text);
      }
      if (isExactMatchTerm) {
        // Case-insensitive whole-word match.
        const regex = new RegExp(`(^|${boundary})${lowerTerm}(?=$|${boundary})`, "i");
        return regex.test(text);
      }
      return text.toLowerCase().includes(lowerTerm);
    };

    // Search recommended courses (AWS courses only, no NovoEd)
    if (recommendations?.recommendations) {
      recommendations.recommendations.forEach((rec) => {
        const name = rec.course_record?.name || "";
        const summary = rec.course_record?.class_summary || "";
        if (matchesTerm(name) || matchesTerm(summary)) {
          resultMap.set(rec.course_id, {
            name: rec.course_record?.name,
            type: "Course",
            course_id: rec.course_id,
            catalog_id: rec.course_record?.catalog_id,
            class_summary: rec.course_record?.class_summary,
            course_url: rec.course_record?.course_url,
            status: "recommended",
            completion_progress: null,
            last_activity: null,
            drupal_values: {
              topics: rec.topics,
              personas: rec.personas,
              tier: rec.tiers,
              series: rec.series,
              learning_journeys: rec.learning_journeys
            },
            isAdminEnrolled: rec.isAdminEnrolled,
            recommendation: rec
          });
        }
      });
    }

    // Search enrolled courses and learning journeys
    if (learningData?.learning?.enrolled) {
      learningData.learning.enrolled.forEach((item) => {
        if (matchesTerm(item.name) || matchesTerm(item.class_summary)) {
          resultMap.set(item.course_id || item.id, {
            ...item,
            status: "enrolled"
          });
        }
      });
    }

    // Search completed courses and learning journeys
    if (learningData?.learning?.completed) {
      learningData.learning.completed.forEach((item) => {
        if (matchesTerm(item.name) || matchesTerm(item.class_summary)) {
          if (!resultMap.has(item.course_id || item.id)) {
            resultMap.set(item.course_id || item.id, {
              ...item,
              status: "completed"
            });
          }
        }
      });
    }

    // Search learning journeys from the dedicated learning journeys section
    if (learningData?.learning?.learning_journeys) {
      learningData.learning.learning_journeys.forEach((journey) => {
        if (matchesTerm(journey.name) || matchesTerm(journey.class_summary)) {
          if (!resultMap.has(journey.id || journey.catalog_id)) {
            resultMap.set(journey.id || journey.catalog_id, {
              ...journey,
              status: "journey",
              type: "Journey"
            });
          }
        }
      });
    }

    setSearchResults(Array.from(resultMap.values()));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  };

  const handleClearSearch = () => {
    setSearchInput("");
    setSearchTerm("");
    setSearchResults([]);
  };

  // Debounced auto-search when 3+ characters
  useEffect(() => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    if (searchInput.trim().length >= 2) {
      searchDebounceRef.current = setTimeout(() => {
        setSearchTerm(searchInput);
        executeSearch(searchInput);
        handleGAEvent("learning_search", searchInput);
      }, 350);
    } else {
      setSearchTerm("");
      setSearchResults([]);
    }

    return () => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
    };
  }, [searchInput]);

  const getSearchCardButton = (course) => {
    if (course.status === "recommended") {
      return course.isAdminEnrolled ? "START" : "ENROLL";
    } else if (course.status === "enrolled") {
      if (course.type === "Journey") return "VIEW";
      if (course.completion_progress === "in_progress" && course.last_activity) {
        return "Resume";
      }
      return "Start";
    } else if (course.status === "completed") {
      return "VIEW";
    } else if (course.status === "journey") {
      return "VIEW";
    }
    return "ENROLL";
  };

  const getSearchCardGAEvent = (course) => {
    if (course.status === "recommended") return "learning_search_recommended";
    if (course.status === "enrolled") return "learning_search_enrolled";
    if (course.status === "completed") return "learning_search_completed";
    return "learning_search";
  };

  const handleToggle = () => {
    setStep1open((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setStep1open(false);
  };

  return (
    <LearningWrapper>
    <div id="cueslearning">
      {loading && (
        <LearningElement>
          <div className="cmp-learning-container">
            {/* Header */}
            <div className="cmp-learning-header">
              <div className="cmp-learning-header-content">
                <h2>Learning</h2>
              </div>
            </div>

            <div className="loading-container">
              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LearningElement>
      )}

      {!loading && learningData && (
        <>

          <LearningElement>
            <div className="cmp-learning-container">

              {/* Header */}
              <div className="cmp-learning-header">
                <div className="cmp-learning-header-content">
                  <h2>myCUES Learning</h2>
                </div>

                <ul className="cmp-learning-tabs">
                  <li>
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#0c66a5"
                          },
                        },
                      }}
                      PopperProps={{
                        popperOptions: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, 10], // adjust the offset as needed
                              },
                            },
                          ],
                        },
                      }}
                     
                      open={step1open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      style={{ backgroundColor: '#0c66a5!important' }}
                      className="custom-tooltip"
                      arrow
                      backgroundColor="#0c66a5"
                      title={
                        <ClickAwayListener onClickAway={() => setStep1open(false)}>
                          <div style={{ width: 300, height: "auto", padding: '20px', marginBottom:'15px' }}>
                            <h2 style={{fontSize:'16px', marginBottom:'5px', fontWeight:"600"}}>Welcome to myCUES Learning!</h2>
                            <p style={{marginBottom:"15px",fontSize:"14px"}}>Here you'll find recommended courses based on your interests and engagement.</p>
                            <a onClick={() => { setStep1open(false);setStep2open(true);setActiveTab("enrolled"); }} 
                              style={{
                                color:"red!important",
                                borderRadius:"30px",
                                border:"1.5px solid #fff",
                                padding: "4px 16px",
                                fontSize:"14px",
                                fontWeight: "700",
                                float:"right"
                              }}
                              onMouseEnter={e => {e.target.style.color = '#0c66a5';e.target.style.backgroundColor="#fff"}} // Change color on hover
                              onMouseLeave={e => {e.target.style.color = '#fff';e.target.style.backgroundColor="#0c66a5"}} // Revert color on mouse out
                            >Got it</a>
                          </div>
                        </ClickAwayListener>
                      }
                    >
                      <button
                        className={activeTab == "recommended" ? "active" : ""}
                        onClick={() => {
                          setActiveTab("recommended");
                        }}
                      >
                        Courses Recommended for {cmpData.account_info.firstName}
                      </button>
                    </Tooltip>

                  </li>
                  <li>
                  <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#0c66a5"
                          },
                        },
                      }}
                      PopperProps={{
                        popperOptions: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, 10], // adjust the offset as needed
                              },
                            },
                          ],
                        },
                      }}
                     
                      open={step2open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      style={{ backgroundColor: '#0c66a5!important' }}
                      className="custom-tooltip"
                      arrow
                      backgroundColor="#0c66a5"
                      title={
                        <ClickAwayListener onClickAway={() => setStep2open(false)}>
                          <div style={{ width: 300, height: "auto", padding: '20px', marginBottom:'15px' }}>
                            <h2 style={{fontSize:'16px', marginBottom:'5px', fontWeight:"600"}}>Enrolled</h2>
                            <p style={{marginBottom:"15px",fontSize:"14px"}}>Here you'll find all of the courses and learning journeys you're currently enrolled in.</p>
                            <a onClick={() => { setStep2open(false);setStep3open(true); setActiveTab("completed");}} 
                              style={{
                                color:"red!important",
                                borderRadius:"30px",
                                border:"1.5px solid #fff",
                                padding: "4px 16px",
                                fontSize:"14px",
                                fontWeight: "700",
                                float:"right"
                              }}
                              onMouseEnter={e => {e.target.style.color = '#0c66a5';e.target.style.backgroundColor="#fff"}} // Change color on hover
                              onMouseLeave={e => {e.target.style.color = '#fff';e.target.style.backgroundColor="#0c66a5"}} // Revert color on mouse out
                            >Got it</a>
                          </div>
                        </ClickAwayListener>
                      }
                    >
                      <button
                        className={activeTab == "enrolled" ? "active" : ""}
                        onClick={() => {
                          setActiveTab("enrolled");
                        }}
                      >
                        Enrolled
                      </button>
                    </Tooltip>

                  </li>
                  <li>
                  <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#0c66a5"
                          },
                        },
                      }}
                      PopperProps={{
                        popperOptions: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, 10], // adjust the offset as needed
                              },
                            },
                          ],
                        },
                      }}
                     
                      open={step3open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      style={{ backgroundColor: '#0c66a5!important' }}
                      className="custom-tooltip"
                      arrow
                      backgroundColor="#0c66a5"
                      title={
                        <ClickAwayListener onClickAway={() => { setStep3open(false); setStep4open(true); setActiveTab("search"); }}>
                          <div style={{ width: 300, height: "auto", padding: '20px', marginBottom:'15px' }}>
                            <h2 style={{fontSize:'16px', marginBottom:'5px', fontWeight:"600"}}>Completed</h2>
                            <p style={{marginBottom:"15px",fontSize:"14px"}}>Here you may view completed courses and download certificates of completion.</p>
                            <a onClick={() => { setStep3open(false);setStep4open(true);setActiveTab("search"); }} 
                              style={{
                                color:"red!important",
                                fontWeight: "700",
                                borderRadius:"30px",
                                border:"1.5px solid #fff",
                                padding: "4px 16px",
                                fontSize:"14px",
                                
                                float:"right"
                              }}
                              onMouseEnter={e => {e.target.style.color = '#0c66a5';e.target.style.backgroundColor="#fff"}} // Change color on hover
                              onMouseLeave={e => {e.target.style.color = '#fff';e.target.style.backgroundColor="#0c66a5"}} // Revert color on mouse out
                            >Got it</a>
                          </div>
                        </ClickAwayListener>
                      }
                    >
                     <button
                      className={activeTab == "completed" ? "active" : ""}
                      onClick={() => {
                        setActiveTab("completed");
                      }}
                    >
                      Completed
                    </button>
                    </Tooltip>
                    
                  </li>
                  <li>
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#0c66a5"
                          },
                        },
                      }}
                      PopperProps={{
                        popperOptions: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, 10],
                              },
                            },
                          ],
                        },
                      }}
                     
                      open={step4open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      style={{ backgroundColor: '#0c66a5!important' }}
                      className="custom-tooltip"
                      arrow
                      backgroundColor="#0c66a5"
                      title={
                        <ClickAwayListener onClickAway={() => { setStep4open(false); localStorage.setItem('hasViewedOverlay', 'true'); localStorage.setItem('hasViewedSearchOverlay', 'true'); }}>
                          <div style={{ width: 300, height: "auto", padding: '20px', marginBottom:'15px' }}>
                            <h2 style={{fontSize:'16px', marginBottom:'5px', fontWeight:"600"}}>Search</h2>
                            <p style={{marginBottom:"15px",fontSize:"14px"}}>Looking for something specific? Search courses and learning journeys to find the learning opportunities you need.</p>
                            <a onClick={() => { setStep4open(false); localStorage.setItem('hasViewedOverlay', 'true'); localStorage.setItem('hasViewedSearchOverlay', 'true'); setActiveTab("recommended"); }} 
                              style={{
                                color:"red!important",
                                fontWeight: "700",
                                borderRadius:"30px",
                                border:"1.5px solid #fff",
                                padding: "4px 16px",
                                fontSize:"14px",
                                
                                float:"right"
                              }}
                              onMouseEnter={e => {e.target.style.color = '#0c66a5';e.target.style.backgroundColor="#fff"}}
                              onMouseLeave={e => {e.target.style.color = '#fff';e.target.style.backgroundColor="#0c66a5"}}
                            >Got it</a>
                          </div>
                        </ClickAwayListener>
                      }
                    >
                      <button
                        className={activeTab == "search" ? "active" : ""}
                        onClick={() => {
                          setActiveTab("search");
                        }}
                      >
                        Search
                      </button>
                    </Tooltip>
                  </li>
                </ul>

                <a
                  href={"https://cues.novoed.com/#!/users/sign_in"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cmp-clp-visit-button"
                  onClick={() => {
                    handleGAEvent("learning_visitportal");
                  }}
                >
                  CUES LEARNING PORTAL
                </a>
              </div>

              {activeTab == "recommended" && (
                <>

                  {/* Desktop/Tablet - Slider */}
                  <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                    {recommendations && recommendations.recommendations.length > 0 ? (
                      <>
                        <Swiper
                          simulateTouch={false}
                          slidesPerView={1} // Default slidesPerView
                          slidesPerGroup={1} // Default slidesPerGroup
                          freeMode={false}
                          grid={{
                            rows: 2,
                          }}
                          spaceBetween={30}
                          onSwiper={(swiper) => setCurrentSwiper(swiper)}

                          // pagination={{
                          //   clickable: true,
                          // }}
                          pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                              return ``;
                            }
                          }}
                          modules={[Grid, Pagination]}
                          className="mySwiper"
                          breakpoints={{
                            480: {
                              slidesPerView: 1,
                              slidesPerGroup: 1,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                            769: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                          }}
                        >
                          <>
                            {Object.values(recommendations.recommendations).slice(0,18).map((course) => (
                              <SwiperSlide key={course.course_id}>
                                <div className="cmp-learning-card"
                                  data-learning-type={`${course.course_record.type}`}
                                  data-learning-id={`${course.course_id}`}
                                  data-catalog-id={`${course.course_record.catalog_id}`}
                                  data-topics={`${course.topics}`}
                                  data-personas={`${course.personas}`}
                                  data-learning-journeys={`${course.learning_journeys}`}
                                  data-novoed-status="none"
                                  data-view-roles={`${course.tiers}`}
                                  data-course-series={`${course.series}`}
                                  data-recommended-course="true"
                                >

                                  <div className="cmp-learning-card-header">
                                    <span className="cmp-learning-type"><img src={icnCourse} />COURSE</span>
                                    {course.course_record?.name && (
                                      <p className="cmp-learning-card-title">
                                        {truncateStringWithPTag(course.course_record?.name, 52)}
                                      </p>
                                    )}
                                    {/* {course.class_summary &&
                                  ( */}

                                    <div className="cmp-learning-card-course-length">
                                    <RecommendationSummary title={course.course_record?.name} summary={course.course_record?.class_summary} maxLength={100} url={course.course_record?.course_url} />
                                    </div>
                                  </div>

                                  <div className="cmp-learning-card-footer">
                                    {course.course_record?.course_url && (
                                      <a
                                        href={course.course_record?.course_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="cmp-learning-card-link resume"
                                        onClick={() => {
                                          handleRecommendationClick(course);
                                          // handleGAEvent(
                                          //   "learning_assigned",
                                          //   course.name
                                          // );
                                        }}
                                      >
                                        {course.isAdminEnrolled ? 'START' : 'ENROLL'}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </>
                        </Swiper>
                        <SwiperPager swiper={currentSwiper} itemCount={recommendations.recommendations.slice(0,18).length} pageRangeCount={8}
                          itemsPerPage={9} currentPage={0}></SwiperPager>


                      </>
                    ) : (
                      <div className="cmp-learning-card recommendations empty">
                        <div className="cmp-learning-card-header">
                          <span className="cmp-learning-type"><img src={icnCourse} />COURSE RECOMMENDATIONS</span>
                          <p className="cmp-learning-card-title">
                            CUES Learning Portal
                          </p>
                          <div className="cmp-learning-card-course-length">
                          Head to CUES Learning Portal to View curated resources to enhance your skills and knowledge.
                          </div>
                          {/* )} */}

                        </div>

                        <div className="cmp-learning-card-footer">

                          <a
                            href="https://cues.novoed.com/#!/users/sign_in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cmp-learning-card-link resume"
                          // onClick={() => {
                          //   handleGAEvent(
                          //     "learning_assigned",
                          //     course.name
                          //   );
                          // }}
                          >
                           EXPLORE NOW 
                          </a>

                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {activeTab == "enrolled" && (
                <>

                  {/* Desktop/Tablet - Slider */}
                  <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                    {courses && courses.length > 0 ? (
                      <>
                        <Swiper
                          simulateTouch={false}
                          slidesPerView={1}
                          freeMode={false}
                          grid={{
                            rows: 2,
                          }}
                          spaceBetween={30}
                          pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                              return ``;
                            }
                          }}
                          onSwiper={(swiper) => setCurrentSwiper(swiper)}
                          modules={[Grid, Pagination]}
                          className="mySwiper"
                          breakpoints={{
                            480: {
                              slidesPerView: 1,
                              slidesPerGroup: 1,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                            769: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                          }}
                        >
                          <>
                            {Object.values(courses).map((course) => (
                              <SwiperSlide key={course.course_id}>
                                <div className="cmp-learning-card"
                                  data-learning-type={`${course.type}`}
                                  data-learning-id={`${course.course_id}`}
                                  data-catalog-id={`${course.catalog_id}`}
                                  data-topics={course.drupal_values && course.drupal_values.topics ? `${course.drupal_values.topics}` : ''}
                                  data-personas={course.drupal_values && course.drupal_values.personas ? `${course.drupal_values.personas}` : ''}
                                  data-learning-journeys={course.drupal_values && course.drupal_values.learning_journeys ? `${course.drupal_values.learning_journeys}` : ''}
                                  data-novoed-status={`${course.completion_progress}`}
                                  data-view-roles={course.drupal_values && course.drupal_values.tier ? `${course.drupal_values.tier}` : ''}
                                  data-course-series={course.drupal_values && course.drupal_values.series ? `${course.drupal_values.series}` : ''}
                                  data-recommended-course="false"
                                >
                                  <div className="cmp-learning-card-header">
                                    {course.type && course.type === 'Course' && (
                                      <span className="cmp-learning-type"><img src={icnCourse} />Course</span>
                                    )}

                                    {course.type && course.type === 'Journey' && (
                                      <span className="cmp-learning-type"><img src={icnJourney} />Learning Journey</span>
                                    )}

                                    {course.name && (
                                      <p className="cmp-learning-card-title">
                                        {truncateStringWithPTag(course.name, 52)}
                                      </p>
                                    )}
                                    {/* {course.class_summary &&
                                  ( */}

                                    <div className="cmp-learning-card-course-length">
                                      {truncateStringWithPTag(course.class_summary, 100)}
                                    </div>
                                    {/* )} */}

                                  </div>

                                  <div className="cmp-learning-card-footer">
                                    {course.course_url && (
                                      <a
                                        href={course.course_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="cmp-learning-card-link resume"
                                        onClick={() => {
                                          handleGAEvent(
                                            "learning_assigned",
                                            course.name
                                          );
                                        }}
                                      >
                                        {course.type === "Journey" && `VIEW`}
                                        {course.type === "Course" && (
                                          <>
                                            {course.completion_progress === "in_progress" && course.last_activity ? `Resume` : `Start`}
                                          </>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </SwiperSlide>

                            ))}
                          </>
                        </Swiper>
                        <SwiperPager swiper={currentSwiper} itemCount={courses.length} pageRangeCount={8}
                          itemsPerPage={9} currentPage={0}></SwiperPager>
                      </>
                    ) : (
                      <div className="cmp-learning-card empty">
                        <div className="cmp-learning-card-header">
                          <div className="cmp-learning-card-title">
                            You're currently not enrolled in any learning. Get started on your own by visiting CUES Learning Portal!
                          </div>
                          {/* )} */}

                        </div>

                        <div className="cmp-learning-card-footer">

                          <a
                            href="https://cues.novoed.com/#!/users/sign_in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cmp-learning-card-link resume"
                          // onClick={() => {
                          //   handleGAEvent(
                          //     "learning_assigned",
                          //     course.name
                          //   );
                          // }}
                          >
                            EXPLORE COURSES
                          </a>

                        </div>
                      </div>

                    )}
                  </div>
                </>
              )}
              {activeTab == "completed" && (
                <>

                  {/* Desktop/Tablet - Slider */}
                  <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                    {courses && courses.length > 0 ? (
                      <>
                        <Swiper
                          simulateTouch={false}
                          slidesPerView={1}
                          freeMode={false}
                          grid={{
                            rows: 2,
                          }}
                          spaceBetween={30}
                          pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                              return ``;
                            }
                          }}
                          modules={[Grid, Pagination]}
                          onSwiper={(swiper) => setCurrentSwiper(swiper)}
                          className="mySwiper"
                          breakpoints={{
                            480: {
                              slidesPerView: 2,
                              slidesPerGroup: 4,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                            769: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                              // grid: {
                              //   rows: 2,
                              // },
                            },
                          }}
                        >
                          <>
                            {Object.values(courses).map((course) => (
                              <SwiperSlide key={course.course_id || course.catalog_id}>
                                <div className="cmp-learning-card"
                                  data-learning-type={`${course.type}`}
                                  data-learning-id={`${course.course_id}`}
                                  data-catalog-id={`${course.catalog_id}`}
                                  data-topics={course.drupal_values && course.drupal_values.topics ? `${course.drupal_values.topics}` : ''}
                                  data-personas={course.drupal_values && course.drupal_values.personas ? `${course.drupal_values.personas}` : ''}
                                  data-learning-journeys={course.drupal_values && course.drupal_values.learning_journeys ? `${course.drupal_values.learning_journeys}` : ''}
                                  data-novoed-status={`${course.completion_progress}`}
                                  data-view-roles={course.drupal_values && course.drupal_values.tier ? `${course.drupal_values.tier}` : ''}
                                  data-course-series={course.drupal_values && course.drupal_values.series ? `${course.drupal_values.series}` : ''}
                                  data-recommended-course="false"
                                >
                                  <div className="cmp-learning-card-header">

                                    {course.type && course.type === 'Course' && (
                                      <span className="cmp-learning-type"><img src={icnCourse} />Course</span>
                                    )}

                                    {course.type && course.type === 'Journey' && (
                                      <span className="cmp-learning-type"><img src={icnJourney} />Learning Journey</span>
                                    )}


                                    {course.name && (
                                      <p className="cmp-learning-card-title">
                                        {truncateStringWithPTag(course.name, 52)}
                                      </p>
                                    )}

                                    {course.class_summary &&
                                      (
                                        <div className="cmp-learning-card-course-length">
                                          {truncateStringWithPTag(course.class_summary, 100)}
                                        </div>
                                      )}
                                  </div>

                                  <div className="cmp-learning-card-footer">
                                    {(course.course_url && (new Date(course.close_date) >= new Date() || course.close_date === null)) && (
                                      <a
                                        href={course.course_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="cmp-learning-card-link"
                                        onClick={() => {
                                          handleGAEvent(
                                            "learning_completed",
                                            course.name
                                          );
                                        }}
                                      >
                                        VIEW
                                      </a>
                                    )}

                                    {course["due-at"] && (
                                      <p className="cmp-learning-card-due-date">
                                        {`Due: ${new Date(
                                          course["due-at"]
                                        ).toLocaleDateString()}`}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </>
                        </Swiper>
                        <SwiperPager swiper={currentSwiper} itemCount={courses.length} pageRangeCount={8}
                          itemsPerPage={9} currentPage={0}></SwiperPager>
                      </>
                    ) : (

                      <div className="cmp-learning-card empty">
                        <div className="cmp-learning-card-header">

                          <p className="cmp-learning-card-title">
                            Get started on your learning journey in CUES Learning Portal!
                          </p>
                          {/* )} */}

                        </div>

                        <div className="cmp-learning-card-footer">

                          <a
                            href="https://cues.novoed.com/#!/users/sign_in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cmp-learning-card-link resume"

                          >
                            EXPLORE COURSES
                          </a>

                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {activeTab == "search" && (
                <div className="cmp-search-tab">
                  <form onSubmit={handleSearchSubmit} className="cmp-search-bar-container">
                    <div className="cmp-search-bar">
                      <svg className="cmp-search-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#E2680E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                      <input
                        type="text"
                        placeholder="Search courses and learning journeys"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        className="cmp-search-input"
                      />
                      {searchInput && (
                        <button type="button" className="cmp-search-clear" onClick={handleClearSearch} aria-label="Clear search">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                        </button>
                      )}
                    </div>
                  </form>

                  {searchTerm && (
                    <div className="cmp-search-results">
                      <p className="cmp-search-results-count">
                        <span>{searchResults.length}</span> {searchResults.length === 1 ? 'Result' : 'Results'}
                      </p>

                      {searchResults.length > 0 ? (
                        <>
                          <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                            <Swiper
                              simulateTouch={false}
                              slidesPerView={1}
                              freeMode={false}
                              grid={{
                                rows: 2,
                              }}
                              spaceBetween={30}
                              pagination={{
                                clickable: true,
                                renderBullet: function (index, className) {
                                  return ``;
                                }
                              }}
                              onSwiper={(swiper) => setSearchSwiper(swiper)}
                              modules={[Grid, Pagination]}
                              className="mySwiper"
                              breakpoints={{
                                480: {
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                                },
                                769: {
                                  slidesPerView: 3,
                                  slidesPerGroup: 3,
                                },
                              }}
                            >
                              <>
                                {searchResults.map((course) => (
                                  <SwiperSlide key={course.course_id || course.id}>
                                    <div className="cmp-learning-card">
                                      <div className="cmp-learning-card-header">
                                        {course.type === "Journey" ? (
                                          <span className="cmp-learning-type"><img src={icnJourney} alt="" />LEARNING JOURNEY</span>
                                        ) : (
                                          <span className="cmp-learning-type"><img src={icnCourse} alt="" />COURSE</span>
                                        )}
                                        {course.name && (
                                          <p className="cmp-learning-card-title">
                                            {truncateStringWithPTag(course.name, 52)}
                                          </p>
                                        )}
                                        <div className="cmp-learning-card-course-length">
                                          {course.status === "recommended" ? (
                                            <RecommendationSummary
                                              title={course.name}
                                              summary={course.class_summary}
                                              maxLength={100}
                                              url={course.course_url}
                                            />
                                          ) : (
                                            truncateStringWithPTag(course.class_summary, 100)
                                          )}
                                        </div>
                                      </div>
                                      <div className="cmp-learning-card-footer">
                                        {course.course_url && (
                                          <a
                                            href={course.course_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="cmp-learning-card-link resume"
                                            onClick={() => {
                                              if (course.status === "recommended" && course.recommendation) {
                                                handleRecommendationClick(course.recommendation);
                                              }
                                              handleGAEvent(getSearchCardGAEvent(course), course.name);
                                            }}
                                          >
                                            {getSearchCardButton(course)}
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </>
                            </Swiper>
                            <SwiperPager swiper={searchSwiper} itemCount={searchResults.length} pageRangeCount={8}
                              itemsPerPage={9} currentPage={0}></SwiperPager>
                          </div>
                        </>
                      ) : (
                        <div className="cmp-search-no-results">
                          <p>No courses or learning journeys found matching "{searchTerm}"</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </LearningElement>
          <LearningJourneyElement>
            {!loading && learningData && (
              <>
                <div className="cmp-learningjourney-container">
                  {/* Header */}
                  <div className="cmp-learningjourney-header">

                    <div className="cmp-learningjourney-header-content">
                      <h2>Discover Tailored Learning Journeys</h2>
                      <p style={{ color: "#fff" }}>Explore thoughtfully crafted learning journeys designed to enhance your professional development growth.</p>
                    </div>

                  </div>
                  <div className="cmp-learningjourney-assignments cmp-learningjourney-assignments-with-slider">
                    {learningData.learning?.learning_journeys && learningData.learning?.learning_journeys.length > 0 ? (
                      <>
                        <Swiper
                          simulateTouch={false}
                          slidesPerView={1}
                          freeMode={false}
                          grid={{
                            rows: 2,
                          }}
                          spaceBetween={30}
                          pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                              return ``;
                            }
                          }}
                          onSwiper={(swiper) => setJourneySwiper(swiper)}
                          modules={[Grid, Pagination]}
                          className="mySwiper"
                          breakpoints={{
                            480: {
                              slidesPerView: 1,
                              slidesPerGroup: 1,
                            },
                            769: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                            },
                          }}
                        >
                          <>
                            {Object.values(getLearningJourneys()).map((course) => (
                              <SwiperSlide key={course.id || course.catalog_id || course.course_id}>
                                <div className="cmp-learningjourney-card" data-learning-type={`${course.type}`} data-learning-id={`${course.id}`} data-catalog-id={`${course.catalog_id}`} data-novoed-status={`${course.novoEdStatus}`} data-personas={course.drupal_values && course.drupal_values.personas ? `${course.drupal_values.personas}` : ''} data-topics={course.drupal_values && course.drupal_values.topics ? `${course.drupal_values.topics}` : ''} data-view-roles={course.drupal_values && course.drupal_values.tier ? `${course.drupal_values.tier}` : ''}>
                                  <div className="cmp-learningjourney-card-header">

                                    {course.type && course.type === 'Course' && (
                                      <span className="cmp-learningjourney-type"><img src={icnCourse} />Course</span>
                                    )}

                                    {course.type && course.type === 'Journey' && (
                                      <span className="cmp-learningjourney-type"><img src={icnJourney} />Learning Journey</span>
                                    )}


                                    {course.name && (
                                      <p className="cmp-learningjourney-card-title">
                                        {truncateStringWithPTag(course.name, 50)}
                                      </p>
                                    )}

                                    {course.class_summary &&
                                      (
                                        <div className="cmp-learningjourney-card-course-length">
                                          {truncateStringWithPTag(course.class_summary, 80)}
                                        </div>
                                      )}
                                  </div>

                                  <div className="cmp-learningjourney-card-footer">
                                    {(course.course_url && (new Date(course.close_date) >= new Date() || course.close_date === null)) && (
                                      <a
                                        href={course.course_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="cmp-learningjourney-card-link"
                                        onClick={() => {
                                          handleGAEvent(
                                            "learning_assigned",
                                            course.name
                                          );
                                        }}
                                      >
                                        VIEW
                                      </a>
                                    )}

                                    {course["due-at"] && (
                                      <p className="cmp-learningjourney-card-due-date">
                                        {`Due: ${new Date(
                                          course["due-at"]
                                        ).toLocaleDateString()}`}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </>
                        </Swiper>
                        <SwiperPager swiper={journeySwiper} itemCount={getLearningJourneys().length} pageRangeCount={8}
                          itemsPerPage={9} currentPage={0}></SwiperPager>
                      </>
                    ) : <></>}
                  </div>


                </div>

              </>
            )}
          </LearningJourneyElement>
        </>
      )}
    </div>
    </LearningWrapper>
  );
};

export default Learning;
